import styled from 'styled-components';

export const ContainerTable = styled.div`
  margin: auto;
  width: 98%;
`;
